<template>
 <div class="help-fourth-page">
  <div class="help-fifth-page-img-holder">
    <div :class="lang === 'en' ? 'help-5-img-u-l-en' : 'help-5-img-u-l'">
    </div>
    <div :class="lang === 'en' ? 'help-5-img-u-r-en' : 'help-5-img-u-r'">
    </div>
  </div>
  <div class="help-text-content-fifth-upper" data-langname="lb_help_51">
  </div>
  <div class="help-text-content-fourth-lower" data-langname="lb_help_52">
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.query.lang,
    };
  }
}
</script>
